import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "stepOneInternalUserYes", "policyException", "targetOne", "targetTwo", "field",
    "policyExceptionCaseNumber", "caseNumber"
  ]

  connect() {
    this.showStepOne()
    this.toggleTarget()
  }

  toggleTarget(event) {
    if (event == null) return

    this.toggleButton(event.target, this.targetOneTarget)
    this.toggleButton(event.target, this.targetTwoTarget)
  }

  toggleButton(input, target) {
    target.disabled = !input.checked
  }

  toggleField(event) {
    const value = event.target.value

    if (value === "case_number") {
      this.fieldTarget.style.display = "block"
      document.getElementById("permission_body").classList.add("hide")
      // hides custom alert message on class
      document.querySelector(".help-block").classList.add("hide")
    } else if (value === "property_admin") {
      this.fieldTarget.style.display = "none"
      document.getElementById("permission_body").classList.add("hide")
      document.querySelector(".alert_message").classList.remove("has-error")
    } else {
      this.fieldTarget.style.display = "none"
      document.getElementById("permission_body").classList.remove("hide")
      document.querySelector(".alert_message").classList.remove("has-error")
    }
  }

  showStepOne() {
    document.getElementById("step_1").classList.remove("hide")
    document.getElementById("step_2").classList.add("hide")
  }

  showStepTwo(event) {
    if (this.stepOneInternalUserYesTarget.checked) return

    event.preventDefault()
    document.getElementById("step_1").classList.add("hide")
    document.getElementById("step_2").classList.remove("hide")
    document.getElementById("permission_body").classList.add("hide")

    this.toggleButton(this.policyExceptionTarget, this.targetTwoTarget)
  }

  validateField(event) {
    const value = this.caseNumberTarget.value
    const non_numeric_characters = /\D/.test(value)

    if (!this.policyExceptionCaseNumberTarget.checked) return

    if (value.length < 1) {
      document.querySelector(".alert_message").classList.add("has-error")
      document.querySelector(".help-block").classList.remove("hide")
      document.querySelector(".alert_message .help-block").textContent = "Your case number can't be blank."
      event.preventDefault()
    }

    if (non_numeric_characters) {
      document.querySelector(".alert_message").classList.add("has-error")
      document.querySelector(".help-block").classList.remove("hide")
      document.querySelector(".alert_message .help-block").textContent = "Your case number must contain numeric characters only."
      event.preventDefault()
    }
  }
}
